<div class="CYOT-Step1popup">
    <!-- <button class="CYOT-steps-back">
        <img src="assets/img/back-button.svg" alt="" class="CYOT-steps-backimg" />
    </button> -->
    <button class="CYOT-steps-cross" [mat-dialog-close]="true">
        <img src="assets/img/filter-close-icon.png" class="CYOT-steps-crossimg" alt="" />
    </button>
    
        <h3 class="CYOT-popup-heading">Share</h3> 
        <div class="CYOT-shareic-wrp">
            
            <button class="CYOT-socimg-h" mat-fab shareButton="whatsapp"
            #whtsappBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="whtsappBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fab fa-whatsapp CYOTwhatsapp-ic"></i>
                </div>
                <span class="CYOT-socl-text">Whatsapp</span>
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="facebook"
            #fbBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="fbBtn?.color">
            <div class="CYOT-icon-outer">
                <i class="fab fa-facebook-f CYOT-fb-ic"></i>
            </div>
            <span class="CYOT-socl-text">Facebook</span>
            <!-- <fa-icon *ngIf="fbBtn" [icon]="fbBtn.icon" size="lg"></fa-icon> -->
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="twitter"
            #twtBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="twtBtn?.color">
                <div class="CYOT-icon-outer">
                   <i class="fab fa-twitter CYOT-tweet-ic"></i>
                </div>
                <span class="CYOT-socl-text">Twitter</span>
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="linkedin"
            #lnkdinBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="lnkdinBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fab fa-linkedin-in CYOT-linkedin-ic"></i>
                </div>
                <span class="CYOT-socl-text">Linkedin</span>
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="pinterest"
            #pnintBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="pnintBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fab fa-pinterest-p CYOT-pinterest-ic"></i>
                </div>
                <span class="CYOT-socl-text">Pinterest</span>
            </button>           

            <button class="CYOT-socimg-h" mat-fab shareButton="reddit"
            #rdtBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="rdtBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fab fa-reddit CYOT-reddit-ic"></i>
                </div>
                <span class="CYOT-socl-text">Reddit</span>
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="xing"
            #xingBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="xingBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fab fa-xing CYOT-xing-ic"></i>
                </div>
                <span class="CYOT-socl-text">Xing</span>
            </button>

            <button class="CYOT-socimg-h" mat-fab shareButton="email"
            #emailBtn="shareButton"
            [url]="rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'"
            [style.backgroundColor]="emailBtn?.color">
                <div class="CYOT-icon-outer">
                    <i class="fas fa-envelope CYOT-email-ic"></i>
                </div>
                <span class="CYOT-socl-text">Email</span>
            </button>
        </div>
        
        <!-- <ul class="CYOT-shareic-wrp">
            <li class="CYOT-iner-bx-s">
                <span class="CYOT-socimg-h">
                    <img src="assets/img/CYOT-whatsapp.png" class="CYOT-wimg-soc" alt="" />
                </span>
                <p class="CYOT-socl-text">Whatsapp</p>
            </li>

            <li class="CYOT-iner-bx-s">
                <span class="CYOT-socimg-h">
                    <img src="assets/img/facebook-icon.svg" class="CYOT-wimg-soc" alt="" />
                </span>
                <p class="CYOT-socl-text">Facebook</p>
            </li>

            <li class="CYOT-iner-bx-s">
                <span class="CYOT-socimg-h">
                    <img src="assets/img/twitter-icon.svg" class="CYOT-wimg-soc" alt="" />
                </span>
                <p class="CYOT-socl-text">Twitter</p>
            </li>

            <li class="CYOT-iner-bx-s">
                <span class="CYOT-socimg-h">
                    <img src="assets/img/instagram-icon.svg" class="CYOT-wimg-soc" alt="" />
                </span>
                <p class="CYOT-socl-text">Instagram</p>
            </li>

        </ul> -->
        <!-- <button type="button" class="CYOT-btnchang">Challenge in leaderboard</button> -->
        <p class="CYOT-sharingtext">You can also share the test by sharing this link</p>
        <div class="CYOT-socialwrpp">
            <div class="CYOT-copytext-cont">
                
                <input #shareUrlinput type="text" name="" value="{{rooturl + '/cyot?ruleId=' + testData.ruleId  + '&isFromShareLink=true'}}"  class="CYOT-writerinput" />
                <button type="button" (click)="copyShareUrl(shareUrlinput)" class="CYOT-copybtn"><img src="assets/img/CYOT-copy-blue.svg" alt="">
                    <span class="CYOT-tooltip" *ngIf="showCoupon">Copied</span>
                </button>
            </div>            
        </div>
 </div>
